<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de consultas finalizadas">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-consulta-finalizada/List'

export default {
    components: {List},
}
</script>